"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NotSynced_exports = {};
__export(NotSynced_exports, {
  default: () => NotSynced_default
});
module.exports = __toCommonJS(NotSynced_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.67384 3.76467C3.90362 3.53489 4.27616 3.53489 4.50594 3.76467L20.737 19.9956C20.9668 20.2254 20.9668 20.598 20.737 20.8277C20.5073 21.0575 20.1347 21.0575 19.9049 20.8277L17.8199 18.7428C16.3535 19.9054 14.4989 20.5999 12.4815 20.5999C11.4155 20.5999 10.4667 20.4683 9.53868 20.1252C8.61229 19.7827 7.73775 19.2411 6.8047 18.46C5.87279 17.6798 5.16876 16.9 4.69657 16.3138C4.62593 16.2261 4.5604 16.1427 4.5 16.0641L4.5 17.4999C4.5 17.8313 4.23137 18.0999 3.9 18.0999C3.56863 18.0999 3.3 17.8313 3.3 17.4999L3.3 14.9999C3.3 14.3924 3.79249 13.8999 4.4 13.8999L6.9 13.8999C7.23137 13.8999 7.5 14.1685 7.5 14.4999C7.50001 14.8313 7.23138 15.0999 6.90001 15.0999L5.27695 15.0999C5.37159 15.2297 5.4897 15.3855 5.63107 15.561C6.06514 16.0999 6.71529 16.8201 7.57503 17.5399C8.43362 18.2587 9.19047 18.7171 9.95476 18.9996C10.7175 19.2816 11.5187 19.3999 12.4815 19.3999C14.1666 19.3999 15.7205 18.8366 16.9649 17.8877L6.60413 7.52703C6.21133 8.04398 5.88493 8.6142 5.63768 9.22503C5.51334 9.53219 5.16354 9.6804 4.85638 9.55607C4.54923 9.43173 4.40102 9.08193 4.52535 8.77477C4.83345 8.01365 5.2474 7.30659 5.74898 6.67189L3.67384 4.59677C3.44407 4.36699 3.44407 3.99445 3.67384 3.76467Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.22269 5.9605C9.43064 5.10349 10.9067 4.5999 12.5 4.5999C13.4628 4.5999 14.264 4.71823 15.0267 5.00018C15.791 5.28272 16.5479 5.74112 17.4065 6.45995C18.2662 7.17975 18.9164 7.89996 19.3504 8.4388C19.4918 8.61429 19.6099 8.77012 19.7046 8.89989L18.1 8.8999C17.7686 8.8999 17.5 9.16853 17.5 9.4999C17.5 9.83128 17.7686 10.0999 18.1 10.0999L20.6 10.0999C21.2075 10.0999 21.7 9.6074 21.7 8.99989L21.7 6.4999C21.7 6.16853 21.4314 5.8999 21.1 5.8999C20.7686 5.8999 20.5 6.16853 20.5 6.4999V7.95983C20.4345 7.87429 20.3629 7.78273 20.2849 7.686C19.8127 7.09984 19.1087 6.32006 18.1768 5.53985C17.2438 4.75868 16.3692 4.21709 15.4428 3.87462C14.5148 3.53157 13.566 3.3999 12.5 3.3999C10.5743 3.3999 8.79679 4.03279 7.36376 5.10157L8.22269 5.9605Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.3438 14.7748C19.129 15.3054 18.8545 15.8054 18.5286 16.2665L19.3877 17.1255C19.8199 16.5441 20.1804 15.9062 20.4562 15.2251C20.5805 14.9179 20.4323 14.5681 20.1251 14.4438C19.818 14.3194 19.4682 14.4676 19.3438 14.7748Z",
      fill: "currentColor"
    }
  )
);
const SvgNotSynced = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var NotSynced_default = SvgNotSynced;
